<template>
    <div class="tags">
        <span class="is-truncated">
            <span
                class="tag is-white"
                v-for="targetGroup in targetGroups"
                v-bind:key="targetGroup"
            >{{ targetGroup }}</span>
        </span>
    </div>
</template>

<script>
import { getValueWithKey } from '@utilities/functions';

import Cell from './cell';

export default {
    mixins: [ Cell ],

    computed: {
        targetGroups: function () {
            const optionList = this.options && this.options.targetGroups ? this.options.targetGroups : [];
            return (this.value || []).map(key => getValueWithKey({key, optionList}) || key);
        }
    }
}
</script>
